import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment } from "react";
import { findUsedGcmConsentTypes } from "@devowl-wp/cookie-consent-web-client";
import { useBanner } from "../../../contexts/banner.js";
import { useGroupItems } from "../../../hooks/common/useGroupItems.js";
import { GcmConsentType } from "../../common/gcm/consentType.js";
import { Group } from "../../common/groups/group.js";
import { GroupList } from "../../common/groups/groupList.js";
import { BANNER_GROUP_NON_STANDARD_STYLE } from "../body/body.js";
const BannerGcmGroupList = ()=>{
    const banner = useBanner();
    const { i18n: { purposes, gcm: { standard, standardDesc, moreInfo, moreInfoLink } }, designVersion } = banner;
    const allServices = useGroupItems();
    const services = findUsedGcmConsentTypes(allServices);
    return /*#__PURE__*/ _jsxs(Fragment, {
        children: [
            /*#__PURE__*/ _jsxs(Group, {
                headline: standard,
                style: BANNER_GROUP_NON_STANDARD_STYLE,
                borderless: true,
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        children: standardDesc
                    }),
                    designVersion > 10 && /*#__PURE__*/ _jsxs("div", {
                        style: {
                            marginTop: 5
                        },
                        children: [
                            moreInfo,
                            "\xa0",
                            /*#__PURE__*/ _jsx("a", {
                                href: moreInfoLink,
                                target: "_blank",
                                rel: "noopener noreferrer",
                                children: moreInfoLink
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(GroupList, {
                children: /*#__PURE__*/ _jsx(Group, {
                    headline: purposes,
                    children: services.map((type)=>/*#__PURE__*/ _jsx(GcmConsentType, {
                            type: type,
                            isBold: true
                        }, type))
                })
            })
        ]
    });
};
export { BannerGcmGroupList };
